import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Campaigns from './pages/Campaigns';
import Coins from './pages/Coins';
import Payments from './pages/Payments';
import Notifications from './pages/Notifications';
import Support from './pages/Support';
import SupportChat from './pages/SupportChat'; // Add this import
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import Applications from './pages/Applications';
import Reports from './pages/Reports';
import AuditLogs from './pages/AuditLogs';
import FAQ from './pages/FAQ';
import Banners from './pages/Banners';
import UserInstagramDetails from './pages/UserInstagramDetails'; // Add this import
import Announcements from './pages/Announcements'; // Add this import
import Collaborations from './pages/Collaborations';
import Ratings from './pages/Ratings';
import TutorialVideos from './pages/TutorialVideos';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" replace />;
};

// App Routes Component
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="coins" element={<Coins />} />
        <Route path="payments" element={<Payments />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="support" element={<Support />} />
        <Route path="support-chat" element={<SupportChat />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profile" element={<Profile />} />
        <Route path="applications" element={<Applications />} />
        <Route path="reports" element={<Reports />} />
        <Route path="audit-logs" element={<AuditLogs />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="banners" element={<Banners />} />
        <Route path="user-instagram-details" element={<UserInstagramDetails />} />
        <Route path="announcements" element={<Announcements />} /> {/* <-- Add this line */}
        <Route path="collaborations" element={<Collaborations />} />
        <Route path="ratings" element={<Ratings />} />
        <Route path="tutorial-videos" element={<TutorialVideos />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

// Main App Component
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10B981',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 4000,
                iconTheme: {
                  primary: '#EF4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
